import type { CurrentUserClients } from '@ms/yammer-graphql';
import { normalize } from 'normalizr';

import { currentNetworkSchema } from './schemas/currentNetwork';
import { userSchema } from './schemas/user';
import type { NormalizedCurrentUser, NormalizedCurrentUserEntities } from './types';

type CurrentUserNormalizer = (response: { readonly data: CurrentUserClients }) => NormalizedCurrentUser;

export const normalizeCurrentUser: CurrentUserNormalizer = (response) => {
  const currentNetworkFields = {
    ...response.data.viewer.user.network,
    ...response.data.settings.network,
  };

  const { entities: entitiesForUser, result } = normalize<unknown, NormalizedCurrentUserEntities>(
    response.data.viewer.user,
    userSchema
  );
  const { entities: entitiesForNetwork } = normalize<unknown, NormalizedCurrentUserEntities>(
    currentNetworkFields,
    currentNetworkSchema
  );

  const {
    user: { isGuest, reactionAccentColor },
    isNetworkAdmin,
    isRestrictedToViewOnlyMode,
    isVerifiedNetworkAdmin,
    locale,
    userPreferences,
    canScheduleAndCreateTeamsMeeting,
    canSendOnBehalfOf,
    directMessageThreadStarterSmallFileUploadUrl,
  } = response.data.viewer;
  const isUserForceOptedIn = !userPreferences.canChangeWebClientPreference;
  const entities = {
    ...entitiesForUser,
    ...entitiesForNetwork,
  };

  return {
    entities,
    result,
    locale,
    isGuest,
    isNetworkAdmin,
    isRestrictedToViewOnlyMode,
    isVerifiedNetworkAdmin,
    userPreferences,
    isUserForceOptedIn,
    canScheduleAndCreateTeamsMeeting,
    canSendOnBehalfOf,
    directMessageThreadStarterSmallFileUploadUrl,
    reactionAccentColor,
  };
};
